import Drawer from 'flowbite/lib/esm/components/drawer';
import DrawerInterface from 'flowbite/lib/esm/components/drawer';
import type { DrawerOptions } from 'flowbite/lib/esm/components/drawer/types';
// InstanceOptions type inlined due to missing module
type InstanceOptions = {
    id: string;
    override?: boolean;
};

export class CustomDrawer {
    private drawer: DrawerInterface | null = null;
    private $targetEl: HTMLElement | null;
    private $buttonOpens: NodeListOf<HTMLElement>;
    private $buttonCloses: HTMLElement | null;
    private $body: HTMLElement | null = document.body;
    private $currentOpenButton: HTMLElement | null;
    private $siteWrapper: HTMLElement | null;
    private $isAnimating: Boolean | false;

    constructor(label: string) {
        this.$targetEl = document.querySelector(`[data-${label}]`);
        this.$buttonOpens = document.querySelectorAll(`[data-${label}-open]`);
        this.$buttonCloses = document.querySelector(`[data-${label}-close]`);
        this.$siteWrapper = document.querySelector('.site-wrapper');
        this.$isAnimating = false;

        if (this.$targetEl && this.$buttonOpens.length && this.$buttonCloses) {
            this.initDrawer(label);
            this.initEscapeListener();
            this.initScrollListener();
        } else {
            console.warn(`LanguageDrawer: Required elements not found for label "${label}".`);
        }
    }

    private initDrawer(label: string) {
        const options: DrawerOptions = {
            placement: 'top',
            backdrop: false,
            bodyScrolling: true,
            edge: false,
            edgeOffset: '',
            backdropClasses: '',
            onHide: () => {
                this.$body?.classList.remove(`drawer-${label}-show`);
                elemDiv.remove();
            },
            onShow: () => {
                this.$body?.classList.add(`drawer-${label}-show`);
                document.body.appendChild(elemDiv);

            },
            onToggle: () => { },
        };

        const elemDiv = document.createElement('div');
        elemDiv.style.cssText = 'position: absolute;width: 100%;height: 100%;z-index: 55;top: -34px;left: 0;';

        const instanceOptions: InstanceOptions = {
            id: label,
            override: true,
        };

        this.drawer = new Drawer(this.$targetEl!, options, instanceOptions);

        this.$buttonOpens.forEach((btn) =>
            btn.addEventListener('click', (el) => {
                this.drawer?.toggle();
                setTimeout(() => this.$buttonCloses.focus(), 200);
                this.$currentOpenButton = btn;
            })
        );

        this.$buttonCloses.addEventListener('click', () => {
            this.drawer?.hide();
            setTimeout(() => this.$currentOpenButton.focus(), 200);
        })

        elemDiv.addEventListener('click', () => {
            if (this.$currentOpenButton) {
                this.drawer?.hide();
                setTimeout(() => this.$currentOpenButton.focus(), 200);
            }
        })

    }

    private initEscapeListener() {
        document.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                this.drawer?.hide();
                if (this.$currentOpenButton) {
                    setTimeout(() => this.$currentOpenButton.focus(), 200);
                }
            }
        });
    }

    private initScrollListener() {
        const isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        window.addEventListener('scroll', () => {  
            if (this.$currentOpenButton && isFireFox == false) {
                this.drawer?.hide();
                setTimeout(() => this.$currentOpenButton.focus(), 200);
            }
        }, { passive: true });
    }

    public getInstance(): DrawerInterface | null {
        return this.drawer;
    }
}